import React from 'react';
import type ApiService from '../Services/ApiService';

export type ApiContextProps = {
    api: ApiService | null,
    setApi: (api: ApiService | null) => void,
    setRefreshConnectedDataRerenderFlag: (value: Date) => void,
};

const ApiContext: React.Context<ApiContextProps> = React.createContext<ApiContextProps>({
    api: null,
    setApi: () => {},
    setRefreshConnectedDataRerenderFlag: () => {},
});

export default ApiContext;